import { HOST } from "../constants/HostConstants";
import { fetchWithCache, getCachedData } from "../services/apiService";

export const propertyByUser = async ({ setProperties }, user_id) => {
  // Show cached data immediately if available
  const cached = getCachedData("/api/property/propertyByUser", { user_id });
  if (cached) {
    setProperties(cached);
  }

  try {
    const data = await fetchWithCache(
      "/api/property/propertyByUser",
      {
        method: "POST",
        body: { user_id },
        params: { user_id },
        retries: 3,
        timeout: 15000,
      },
      true,
    );
    setProperties(data);
  } catch (error) {
    // Keep displaying cached data if available, otherwise empty array
    if (!cached) {
      setProperties([]);
    }
  }
};
